/**
 * `core.uiRequest` consumption (M3 plan §2.4, R16): an activation that needs UI (hail, a finished reboot, the
 * reboot prompt) sets `core.uiRequest`; the station services feature takes it exactly once — cleared before it is
 * routed, so a route that throws or opens nothing never sees it again.
 */
import type { ReachCore, UiRequest } from '../../runtime/types'

export interface UiRequestRoutes {
  services(stationId: string): void
  sponsor(relayId: string): void
  confirmReboot(relayId: string): void
}

/** Clears and routes the pending request; returns its kind, or null when there was none. */
export function takeUiRequest(core: ReachCore, routes: UiRequestRoutes): UiRequest['kind'] | null {
  const req = core.uiRequest
  if (req === null) return null
  core.uiRequest = null
  switch (req.kind) {
    case 'services':
      routes.services(req.stationId)
      break
    case 'sponsor':
      routes.sponsor(req.relayId)
      break
    case 'confirmReboot':
      routes.confirmReboot(req.relayId)
      break
  }
  return req.kind
}
